import { action } from 'typesafe-actions';
import { ResponseError } from '../../../services/api';
import { DashboardMenuTypes, DashboardMenu } from './types';

export const loadDashboardMenuRequest = () => action(DashboardMenuTypes.LOAD_REQUEST);
export const loadSuccess = (data: DashboardMenu[]) => action(DashboardMenuTypes.LOAD_SUCCESS, { data });
export const loadFailure = (error: ResponseError) => action(DashboardMenuTypes.LOAD_FAILURE, { error });
